// Muestra el texto del asistente interpretando Markdown (tablas, listas,
// negritas, código, enlaces). El HTML crudo NO se interpreta: react-markdown
// lo escapa por defecto (no se usa rehype-raw a propósito).
import ReactMarkdown, { type Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';

const components: Components = {
  p: ({ children }) => <p className="my-1">{children}</p>,
  ul: ({ children }) => <ul className="list-disc pl-5 my-1 space-y-0.5">{children}</ul>,
  ol: ({ children }) => <ol className="list-decimal pl-5 my-1 space-y-0.5">{children}</ol>,
  li: ({ children }) => <li>{children}</li>,
  strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
  h1: ({ children }) => <h3 className="font-semibold text-base mt-2 mb-1">{children}</h3>,
  h2: ({ children }) => <h4 className="font-semibold mt-2 mb-1">{children}</h4>,
  h3: ({ children }) => <h5 className="font-semibold mt-2 mb-1">{children}</h5>,
  h4: ({ children }) => <h6 className="font-semibold mt-2 mb-1">{children}</h6>,
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline break-all">
      {children}
    </a>
  ),
  blockquote: ({ children }) => (
    <blockquote className="border-l-2 border-[var(--color-border)] pl-3 my-1 text-[var(--color-text-secondary)]">
      {children}
    </blockquote>
  ),
  hr: () => <hr className="my-2 border-[var(--color-border)]" />,
  pre: ({ children }) => (
    <pre className="my-1 overflow-x-auto rounded bg-black/5 dark:bg-white/10 p-2 font-mono text-xs whitespace-pre [&>code]:bg-transparent [&>code]:p-0">
      {children}
    </pre>
  ),
  code: ({ children }) => (
    <code className="font-mono text-xs rounded bg-black/5 dark:bg-white/10 px-1 py-0.5">{children}</code>
  ),
  table: ({ children }) => (
    <div className="my-1 overflow-x-auto">
      <table className="border-collapse border border-[var(--color-border)]">{children}</table>
    </div>
  ),
  thead: ({ children }) => <thead className="bg-[var(--color-bg-secondary)]">{children}</thead>,
  th: ({ children, style }) => (
    <th style={style} className="border border-[var(--color-border)] px-2 py-1 text-sm font-semibold text-left">
      {children}
    </th>
  ),
  td: ({ children, style }) => (
    <td style={style} className="border border-[var(--color-border)] px-2 py-1 text-sm align-top">
      {children}
    </td>
  ),
};

export function AssistantMarkdown({ text, className = '' }: { text: string; className?: string }) {
  return (
    <div className={`break-words select-text ${className}`}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {text}
      </ReactMarkdown>
    </div>
  );
}

export default AssistantMarkdown;
